<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="80%"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="封面" prop="avatar">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="image_success"
            :on-remove="image_remove"
          >
            <img v-if="form.avatar" :src="form.avatar" class="avatar large">
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
          <span>建议尺寸：343px * 164px</span>
        </el-form-item>
        <el-form-item label="轮播图" prop="imageList">
          <el-upload
            :action="QNUploadURL"
            :data="uploadToken"
            list-type="picture-card"
            :file-list="form.imageList"
            :on-success="imageList_success"
            :on-remove="imageList_remove"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="经度" prop="lng">
          <el-input
            v-model="form.lng"
            class="fix-width"
            placeholder="请输入经度"
          />
        </el-form-item>
        <el-form-item label="维度" prop="lat">
          <el-input
            v-model="form.lat"
            class="fix-width"
            placeholder="请输入维度"
          />
        </el-form-item>
        <el-form-item label="标签">
          <el-select
            v-model="form.tagIdList"
            multiple
            placeholder="请选择标签"
            class="fix-width"
          >
            <el-option
              v-for="item in tagList"
              :key="item.tagId"
              :label="item.title"
              :value="item.tagId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="图文说明" prop="text">
          <tinymce-editor
            :height="460"
            :value="form.text"
            @inputChange="inputChange"
          ></tinymce-editor>
        </el-form-item>
        <el-form-item label="物料清单" prop="packageList">
          <el-button type="primary" size="mini" @click="handleAddPackage">新增</el-button>
          <el-table :data="form.packageList" stripe>
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column label="标题" prop="title" />
            <el-table-column label="图标">
              <template #default="{ row }">
                <img :src="row.icon" class="avatar icon_avatar" />
              </template>
            </el-table-column>
            <el-table-column label="说明">
              <template #default="{ row }">
                <div v-for="(item, index) in row.itemList" :key="index">
                  {{ item.title }} {{ item.text ? `：${item.text}` : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              width="150"
            >
              <template #default="{ row, $index }">
                <el-button type="primary" @click="handleEditPackage(row, $index)">编辑</el-button>
                <el-button type="error" @click="handleDelPackage($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="游玩提醒列表" prop="arriveTipList">
          <el-button type="primary" size="mini" @click="handleAddArriveTip">新增</el-button>
          <el-table :data="form.arriveTipList" stripe>
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column label="标题" prop="title" />
            <el-table-column label="图标">
              <template #default="{ row }">
                <img :src="row.icon" class="avatar icon_avatar" />
              </template>
            </el-table-column>
            <el-table-column label="说明">
              <template #default="{ row }">
                <div v-for="(item, index) in row.itemList" :key="index">
                  {{ item.title }} {{ item.text ? `：${item.text}` : '' }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              width="150"
            >
              <template #default="{ row, $index }">
                <el-button type="primary" @click="handleEditArrive(row, $index)">编辑</el-button>
                <el-button type="error" @click="handleDelArrive($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="提醒列表" prop="tipList">
          <el-button type="primary" size="mini" @click="handleAddTip">新增</el-button>
          <el-table :data="form.tipList" stripe>
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column label="标题" prop="title" />
            <el-table-column label="说明" prop="text" />
            <el-table-column
              label="操作"
              fixed="right"
              width="150"
            >
              <template #default="{ row, $index }">
                <el-button type="primary" @click="handleEditTip(row, $index)">编辑</el-button>
                <el-button type="error" @click="handleDelTip($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="日程" prop="scheduleList">
          <el-button type="primary" size="mini" @click="handleAddSchedule">新增</el-button>
          <el-table :data="form.scheduleList" stripe>
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column label="标题" prop="title" />
            <el-table-column label="子标题" prop="subTitle" />
            <el-table-column label="详情" prop="text" />
            <el-table-column
              label="操作"
              fixed="right"
              width="150"
            >
              <template #default="{ row, $index }">
                <el-button type="primary" @click="handleEditSchedule(row, $index)">编辑</el-button>
                <el-button type="error" @click="handleDelSchedule($index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="退改规则" prop="refundRuleText">
          <tinymce-editor
            :height="460"
            :value="form.refundRuleText"
            @inputChange="inputRefundChange"
          ></tinymce-editor>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
    <!-- 物料清单编辑 -->
    <el-dialog
      v-model="packageVisible"
      :close-on-click-modal="false"
      :title="packageTitle"
      width="70%"
    >
      <el-form ref="package" :model="packages" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="packages.title"
            placeholder="请输入标题"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="封面" prop="icon">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="packageIconSuccess"
            :on-remove="packageIconRemove"
          >
            <img v-if="packages.icon" :src="packages.icon" class="avatar" >
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="项目列表">
          <el-row>
            <el-col :span="9">名称</el-col>
            <el-col :span="9">备注</el-col>
            <el-col :span="6">操作</el-col>
          </el-row>
          <el-row :gutter="20" v-for="(item, index) in packages.itemList" :key="index">
            <el-col :span="9">
              <el-input v-model="item.title" placeholder="项目名称"></el-input>
            </el-col>
            <el-col :span="9">
              <el-input type="textarea" resize="none" :autosize="{ minRows: 2, maxRows: 5 }" v-model="item.text" placeholder="项目备注"></el-input>
            </el-col>
            <el-col :span="6">
              <i class="el-icon-circle-plus-outline" @click="addPackageItem()"></i>
              <i class="el-icon-remove-outline" @click="minusPackageItem(index)"></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="packageVisible = false">取 消</el-button>
        <el-button type="primary" @click="addPackage">确 定</el-button>
      </template>
    </el-dialog>
    <!-- 游玩提醒编辑 -->
    <el-dialog
      v-model="arriveVisible"
      :close-on-click-modal="false"
      :title="arriveTitle"
      width="70%"
    >
      <el-form ref="arriveTip" :model="arriveTip" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="arriveTip.title"
            placeholder="请输入标题"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="封面" prop="icon">
          <el-upload
            class="avatar-uploader"
            :show-file-list="false"
            :action="QNUploadURL"
            :data="uploadToken"
            :on-success="arriveIconSuccess"
            :on-remove="arriveIconRemove"
          >
            <img v-if="arriveTip.icon" :src="arriveTip.icon" class="avatar" >
            <i v-else class="avatar-uploader-icon el-icon-plus"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="项目列表">
          <el-row>
            <el-col :span="9">名称</el-col>
            <el-col :span="9">备注</el-col>
            <el-col :span="6">操作</el-col>
          </el-row>
          <el-row :gutter="20" v-for="(item, index) in arriveTip.itemList" :key="index">
            <el-col :span="9">
              <el-input v-model="item.title" placeholder="项目名称"></el-input>
            </el-col>
            <el-col :span="9">
              <el-input type="textarea" resize="none" :autosize="{ minRows: 2, maxRows: 5 }" v-model="item.text" placeholder="项目备注"></el-input>
            </el-col>
            <el-col :span="6">
              <i class="el-icon-circle-plus-outline" @click="addArriveTipItem()"></i>
              <i class="el-icon-remove-outline" @click="minusArriveTipItem(index)"></i>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="arriveVisible = false">取 消</el-button>
        <el-button type="primary" @click="addArrive">确 定</el-button>
      </template>
    </el-dialog>
    <!-- 提醒编辑 -->
    <el-dialog
      v-model="tipVisible"
      :close-on-click-modal="false"
      :title="tipTitle"
      width="70%"
    >
      <el-form ref="tip" :model="tip" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="tip.title"
            placeholder="请输入标题"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="说明">
          <el-input type="textarea" resize="none" :autosize="{ minRows: 2, maxRows: 5 }" v-model="tip.text" placeholder="说明"></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="tipVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTip">确 定</el-button>
      </template>
    </el-dialog>
    <!-- 日程编辑 -->
    <el-dialog
      v-model="scheduleVisible"
      :close-on-click-modal="false"
      :title="scheduleTitle"
      width="70%"
    >
      <el-form ref="schedule" :model="schedule" label-width="120px">
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="schedule.title"
            placeholder="请输入标题"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="子标题" prop="subTitle">
          <el-input
            v-model.trim="schedule.subTitle"
            placeholder="请输入子标题"
            class="fix-width"
          />
        </el-form-item>
        <el-form-item label="详情">
          <tinymce-editor
            :height="460"
            :value="schedule.text"
            @inputChange="inputScheduleChange"
          ></tinymce-editor>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="scheduleVisible = false">取 消</el-button>
        <el-button type="primary" @click="addSchedule">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createSpot, updateSpot, findTagAll } from '@/api/ticket'
import { getUploadToken } from '@/api/app'
import { QNUploadURL, QNHost } from '@/config/net.config'
export default {
  name: 'SpotEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      QNUploadURL,
      QNHost,
      uploadToken: null,
      tagList: [],
      form: {
        spotId:'',
        title: '',
        avatar: '',
        imageList: [],
        tagIdList: [],
        lng:'',
        lat:'',
        text: '',
        order: 1,
        packageList: [],
        arriveTipList: [],
        tipList: [],
        refundRuleText: [],
        scheduleList: [],
      },
      // 物料清单
      packages: {
        title: '',
        icon: '',
        itemList: [
          {
            title: '',
            text: ''
          }
        ]
      },
      packageVisible: false,
      packageTitle: '新增物料清单',
      // 游玩提醒列表
      arriveTip: {
        title: '',
        icon: '',
        itemList: [
          {
            title: '',
            text: ''
          }
        ]
      },
      arriveVisible: false,
      arriveTitle: '新增游玩提醒',
      // 提醒列表
      tip: {
        title: '',
        text: '',
      },
      tipVisible: false,
      tipTitle: '新增提醒',
      // 日程列表
      schedule: {
        title: '',
        subTitle: '',
        text: ''
      },
      scheduleVisible: false,
      scheduleTitle: '新增日程',
      // 退款规则列表
      refund: {
        title: '',
        text: '',
      },
      refundVisible: false,
      refundTitle: '新增退款规则',
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        avatar: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value.length == 0) {
                callback(new Error('请上传封面'))
              } else {
                callback()
              }
            },
          },
        ],
      },
      dialogFormVisible: false
    }
  },
  methods: {
    // 新增物料清单 start
    handleAddPackage() {
      this.packages = {
        icon: '',
        title: '',
        itemList: [
          {
            title: '',
            text: ''
          }
        ]
      }
      this.packageTitle = '新增物料清单'
      this.packageVisible = true
    },
    handleEditPackage(row, index) {
      this.packages = {
        ...row,
        index
      }
      this.packageTitle = '编辑物料清单'
      this.packageVisible = true
    },
    handleDelPackage(index) {
      this.form.packageList.splice(index, 1)
    },
    addPackageItem() {
      this.packages.itemList.push({
        title: '',
        text: '',
      })
    },
    minusPackageItem(index) {
      this.packages.itemList.splice(index, 1)
    },
    addPackage() {
      const { index, icon, itemList, title } = this.packages
      if (index !== undefined) {
        this.form.packageList.splice(index, 1, {
          title,
          icon,
          itemList
        })
      } else {
        this.form.packageList.push(this.packages)
      }
      this.packageVisible = false
    },
    packageIconSuccess(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.packages.icon = `${QNHost}/${res.hash}`
    },
    packageIconRemove() {
      this.packages.icon = ''
    },
    // 新增物料清单 end
    // 新增游玩提醒清单 start
    handleAddArriveTip() {
      this.arriveTip = {
        icon: '',
        title: '',
        itemList: [
          {
            title: '',
            text: ''
          }
        ]
      }
      this.arriveTitle = '新增游玩提醒'
      this.arriveVisible = true
    },
    handleEditArrive(row, index) {
      this.arriveTip = {
        ...row,
        index
      }
      this.arriveTitle = '编辑游玩提醒'
      this.arriveVisible = true
    },
    handleDelArrive(index) {
      this.form.arriveTipList.splice(index, 1)
    },
    addArriveTipItem() {
      this.arriveTip.itemList.push({
        title: '',
        text: '',
      })
    },
    minusArriveTipItem(index) {
      this.arriveTip.itemList.splice(index, 1)
    },
    addArrive() {
      const { index, icon, itemList, title } = this.arriveTip
      if (index !== undefined) {
        this.form.arriveTipList.splice(index, 1, {
          title,
          icon,
          itemList
        })
      } else {
        this.form.arriveTipList.push(this.arriveTip)
      }
      this.arriveVisible = false
    },
    arriveIconSuccess(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.arriveTip.icon = `${QNHost}/${res.hash}`
    },
    arriveIconRemove() {
      this.arriveTip.icon = ''
    },
    // 新增游玩提醒清单 end
    // 日程相关 start
    handleAddSchedule() {
      this.schedule = {
        title: '',
        subTitle: '',
        text: '',
      }
      this.scheduleTitle = '新增日程'
      this.scheduleVisible = true
    },
    handleEditSchedule(row, index) {
      this.schedule = {
        ...row,
        index
      }
      this.scheduleVisible = true
    },
    handleDelSchedule(index) {
      this.form.scheduleList.splice(index, 1)
    },
    inputScheduleChange(value) {
      this.schedule.text = value
    },
    addSchedule() {
      const { index, title, subTitle, text } = this.schedule
      if (index !== undefined) {
        this.form.scheduleList.splice(index, 1, {
          title,
          subTitle,
          text
        })
      } else {
        this.form.scheduleList.push(this.schedule)
      }
      this.scheduleVisible = false
    },
    // 日程相关 end
    // 提醒相关 start
    handleAddTip() {
      this.tip = {
        title: '',
        text: '',
      }
      this.tipTitle = '新增提醒'
      this.tipVisible = true
    },
    handleEditTip(row, index) {
      this.tip = {
        ...row,
        index
      }
      this.tipTitle = '编辑提醒'
      this.tipVisible = true
    },
    handleDelTip(index) {
      this.form.tipList.splice(index, 1)
    },
    addTip() {
      const { index, title, text } = this.tip
      if (index !== undefined) {
        this.form.tipList.splice(index, 1, {
          title,
          text
        })
      } else {
        this.form.tipList.push(this.tip)
      }
      this.tipVisible = false
    },
    // 提醒相关 end
    inputChange(value) {
      this.form.text = value
    },
    inputRefundChange(value) {
      this.form.refundRuleText = value
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改景区'
        this.form = Object.assign(this.form, row.basic)
        this.form.spotId = row.spotId
        this.form.title = row.title
      } else {
        this.title = '新增景区'
      }
      this.dialogFormVisible = true
      const token = await getUploadToken({})
      const tags = await findTagAll({ typehood: 1 })
      this.tagList = tags || []
      this.uploadToken = { token: token.token }
    },
    // 图片
    imageList_remove(file, fileList) {
      this.form.imageList = fileList.map((e) => ({
        name: e.name,
        url: e.url,
      }))
    },
    image_remove(file, fileList) {
      // this.form.avatar = fileList.map((e) => ({
      //   name: e.name,
      //   url: e.url,
      // }))
      this.form.avatar = ''
    },
    image_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.avatar = `${QNHost}/${res.hash}`
    },
    imageList_success(res, file) {
      if (!res.hash) {
        this.$message.error('图片上传失败')
        return
      }
      this.form.imageList.push({
        name: file.name,
        url: QNHost + '/' + res.hash,
      })
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const spotId = this.form.spotId
          const data = Object.assign({},this.form)
          this.$baseConfirm(
            `你确定要${spotId ? '修改' : '新增'}景区吗`,
            null,
            async () => {
              spotId
                ? await updateSpot(data)
                : await createSpot(data)
              this.$baseMessage(
                `${spotId ? '修改' : '新增'}景区成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all .3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.icon_avatar {
  width: 50px;
  height: 50px;
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.el-icon-circle-plus-outline,
.el-icon-remove-outline {
  font-size: 32px;
  vertical-align: middle;
  cursor: pointer;
}

.el-icon-circle-plus-outline {
  color: #409eff;
}

.el-icon-remove-outline {
  color: #f56c6c;
  margin-left: 15px;
}
</style>
